// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"drawer_icon-container__hvQrH","tabs":"drawer_tabs__qZWVs","a":"drawer_a__dteSj","tab":"drawer_tab__oOODJ","icon":"drawer_icon__N_gRd"};